import axios from "axios";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { apiKey } from "../../../config/config";
import { toast } from "react-toastify";
import handleCSRF from "../../../config/CSRF";

function UploadIngredientsForm() {
  const user = JSON.parse(localStorage.getItem("rms-admin"));
  const [removeAll, setRemoveAll] = useState(false);
  const [ingFile, setIngFile] = useState();
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  const hanldeSubmit = (e) => {
    e.preventDefault();

    const formData = new FormData();

    formData.append("remove_all", removeAll);
    formData.append("ing_file", ingFile);

    const postData = () => {
      axios
        .post(`${apiKey}/api/rms/admin/import-ingredients`, formData, {
          headers: {
            Authorization: `Bearer ${user?.token}`,
          },
        })
        .then((res) => {
          toast.success("Success", {
            position: "bottom-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
          navigate(-1);
        })
        .catch((err) => {
          toast.error(err.response.data.message, {
            position: "bottom-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
        })
        .finally(() => setLoading(false));
    };
    handleCSRF(postData);
  };

  return (
    <main>
      <div className="relative my-16 flex flex-col min-w-0 break-words w-full mb-6 shadow-lg bg-white rounded-lg p-4 border-0">
        <div className="flex justify-between items-center mb-4">
          <div className="flex justify-between items-center mb-4">
            <h1 className="text-d-bg-text text-2xl">Upload Ingredients</h1>
          </div>
        </div>
        <div className="w-full">
          <form className="w-full" onSubmit={hanldeSubmit}>
            <div className="flex flex-col md:flex-row gap-x-8 gap-y-2 w-full">
              <label htmlFor="" className="w-full">
                <span className="bg-d-bg-text text-sm mb-2 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2">
                  Upload File
                </span>
                <div className="mb-2 pt-0">
                  <input
                    type="file"
                    onChange={(e) => setIngFile(e.target.files[0])}
                    className="px-2 py-2 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full"
                  />
                </div>
              </label>
            </div>
            <label htmlFor="" className="flex gap-2 my-1">
              <input
                type="checkbox"
                value={removeAll}
                onChange={(e) => setRemoveAll(e.target.checked)}
              />
              <span className="text-d-bg-text text-xs">
                Remove all prevoius data, before uploading new data.
              </span>
            </label>
            <div></div>
            <span className="w-full bg-d-cat-btn h-1 my-2 inline-block"></span>
            <div className="flex gap-2">
              <button
                className="bg-d-cat-btn text-white text-sm px-3 py-1 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150 text-center w-fit relative"
                type="submit"
              >
                {loading && (
                  <span className="absolute top-0 left-0 w-full h-full py-1 px-3 bg-black bg-opacity-50">
                    <img
                      className="w-4 mx-auto"
                      src="https://i.gifer.com/ZKZx.gif"
                      alt=""
                    />
                  </span>
                )}
                Submit
              </button>
              <button
                className="bg-d-cat-btn text-white text-sm px-3 py-1 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150 text-center w-fit"
                type="button"
                onClick={() => navigate(-1)}
              >
                Back
              </button>
              <button
                className="bg-d-cat-btn text-white text-sm px-3 py-1 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150 text-center w-fit"
                type="button"
              >
                Download Sample
              </button>
            </div>
          </form>
        </div>
      </div>
    </main>
  );
}

export default UploadIngredientsForm;
